// Refresco parcial del pictogram-admin-panel.
//
// En vez de recargar TODO el panel cada vez que un editor hoja guarda, este helper
// aplica una actualización parcial e in-place sobre el pictograma según el payload
// que el editor emite junto al evento `epc-pictograms-reload`. Así los cambios que
// no afectan al progreso (nombre, fechas, visibilidad) se reflejan al instante sin
// re-fetch, sin flash y sin perder la posición de navegación.
//
// Contrato del payload (todos opcionales salvo `scope`):
//   {
//     scope: 'layer' | 'pictogram',   // qué se editó
//     layerId?: number|string,        // requerido si scope === 'layer'
//     changes?: object,               // campos a parchear ({ name, scheduled_start_date, ... })
//     affectsProgress?: boolean,      // true si el cambio recalcula progreso (summary)
//   }
//
// Devuelve { patched, needsProgressRefresh }:
//   - patched=false            → el panel debe caer al refresh silencioso (fallback).
//   - patched=true             → los cambios visibles ya se aplicaron in-place.
//   - needsProgressRefresh=true → además hay que refrescar el progreso (summary).

const NOOP = { patched: false, needsProgressRefresh: false };

export function applyReloadPayload(pictogram, payload) {
  if (!pictogram || !payload || typeof payload !== 'object' || !payload.scope) {
    return NOOP;
  }

  const needsProgressRefresh = payload.affectsProgress === true;

  if (payload.scope === 'pictogram') {
    _applyChanges(pictogram, payload.changes);
    return { patched: true, needsProgressRefresh };
  }

  if (payload.scope === 'layer') {
    const layer = _findLayer(pictogram, payload.layerId);
    // Si no localizamos la capa, es más seguro caer al fallback que dejar el panel
    // desincronizado.
    if (!layer) return NOOP;
    _applyChanges(layer, payload.changes);
    return { patched: true, needsProgressRefresh };
  }

  // Scope desconocido → fallback seguro.
  return NOOP;
}

function _findLayer(pictogram, layerId) {
  if (layerId == null || !Array.isArray(pictogram.layers)) return null;
  return pictogram.layers.find((l) => String(l.id) === String(layerId)) || null;
}

// Copia sólo las claves presentes en `changes` sobre el target. Mutación in-place
// para preservar la reactividad de Vue 2 sobre propiedades ya existentes (los campos
// que parcheamos —name, fechas, visibilidad— existen desde la carga inicial).
function _applyChanges(target, changes) {
  if (!target || !changes || typeof changes !== 'object') return;
  Object.keys(changes).forEach((key) => {
    target[key] = changes[key];
  });
}
